(function() {
  const FREE_VARIANT_ID = 57072707600649;
  const GIFT_PARAM = 'fgift';
  const COOKIE_NAME = 'pending_free_gift';

  function setCookie(name, minutes) {
    var expires = new Date(Date.now() + minutes * 60000).toUTCString();
    document.cookie = name + '=1; expires=' + expires + '; path=/';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
  }

  function addFreeGift() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        var alreadyIn = cart.items.some(item => item.variant_id === FREE_VARIANT_ID);
        if (alreadyIn) {
          deleteCookie(COOKIE_NAME);
          return;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: FREE_VARIANT_ID,
            quantity: 1,
            properties: { _free_gift: 'true' }
          })
        });
      })
      .then(() => deleteCookie(COOKIE_NAME))
      .catch(err => console.error('Free gift error:', err));
  }

  function enforceSingleGift() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        var giftItem = cart.items.find(item => item.variant_id === FREE_VARIANT_ID);
        if (giftItem && giftItem.quantity > 1) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: FREE_VARIANT_ID, quantity: 1 })
          });
        }
      });
  }

  // URL-Parameter prüfen → Cookie setzen
  var params = new URLSearchParams(window.location.search);
  if (params.get(GIFT_PARAM) === '1') {
    setCookie(COOKIE_NAME, 60);
  }

  // Cookie vorhanden → Gratis-Artikel hinzufügen
  if (getCookie(COOKIE_NAME)) {
    addFreeGift();
  }

  // Immer prüfen ob Menge > 1
  enforceSingleGift();

})();
